module.exports = __webpack_public_path__ + "static/fonts/PoppinsRegular.093ee89.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/PoppinsRegular.ttf
// module id = 979
// module chunks = 113